var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background-color":"#eeeeee"},attrs:{"theme":"light"}},[_c('nav-bar-sustainability'),_c('VMain',[_c('breadcrumbs'),_c('router-view',{staticClass:"secondary--text"})],1),_c('test-error'),_c('orixe-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }